var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "24px",
    height: "24px",
    fill: "#22E06C",
    viewBox: "4 4 24 24",
    enableBackground: "new 4 4 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic__x2F__thumb"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28,14.91c0-0.579-0.23-1.134-0.64-1.543c-0.408-0.409-0.964-0.639-1.543-0.639h-6.894l1.046-4.985 c0.022-0.109,0.034-0.229,0.034-0.349c0-0.447-0.186-0.862-0.481-1.156l-1.155-1.146l-7.178,7.178 c-0.403,0.404-0.644,0.949-0.644,1.549v10.91c0,0.578,0.229,1.133,0.639,1.541c0.409,0.41,0.964,0.639,1.542,0.639h9.818 c0.905,0,1.681-0.545,2.008-1.33l3.294-7.691C27.945,17.636,28,17.375,28,17.091V14.91z M4,26.908h4.364v-13.09H4V26.908z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/thumb.421a0e6108981cefbd4036874e67169d.svg";
export { ForwardRef as ReactComponent };